import { render, staticRenderFns } from "./ProductACVItemDetails.vue?vue&type=template&id=464f058b&scoped=true&"
import script from "./ProductACVItemDetails.vue?vue&type=script&lang=js&"
export * from "./ProductACVItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f058b",
  null
  
)

export default component.exports